import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocumentLineColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 4,
		fill: "#16A34A",
		fillOpacity: .16
	}), /* @__PURE__ */ _jsx("path", {
		d: "M17.6967 7.875C18.0108 7.87566 18.3216 7.93982 18.6106 8.06299C18.8997 8.18625 19.1614 8.36642 19.3796 8.59277L22.5412 11.883C22.9584 12.3175 23.1906 12.8976 23.1882 13.5V20.3026C23.1984 21.2892 22.8227 22.2408 22.1417 22.9548C21.4606 23.6686 20.5277 24.0887 19.5416 24.125H12.9115C11.915 24.1047 10.9671 23.6897 10.2764 22.971C9.58584 22.2524 9.20892 21.2885 9.22825 20.292V11.5477C9.25334 10.5691 9.65812 9.6387 10.357 8.95329C11.0559 8.26786 11.9944 7.88096 12.9734 7.875H17.6967ZM12.9758 9.125C12.3243 9.12732 11.6992 9.38311 11.2326 9.83789C10.7661 10.2927 10.4947 10.9111 10.4758 11.5623V20.3026C10.4663 20.6325 10.5221 20.9611 10.6402 21.2694C10.7582 21.5773 10.9361 21.8588 11.1635 22.0978C11.391 22.3369 11.6639 22.5285 11.9659 22.6618C12.2678 22.7949 12.593 22.8673 12.9229 22.8742H19.5163C20.1744 22.8444 20.7954 22.56 21.2473 22.0807C21.6993 21.6014 21.9471 20.9646 21.9382 20.3058V13.7214H20.2276C19.4977 13.7183 18.7987 13.4262 18.2834 12.9092C17.7681 12.3921 17.4784 11.6917 17.4778 10.9618V9.12419L12.9758 9.125ZM18.7278 10.9618C18.7278 11.3611 18.8861 11.745 19.168 12.0278C19.45 12.3105 19.8325 12.47 20.2317 12.4714H21.3702L18.7278 9.71826V10.9618Z",
		fill: "#16A34A"
	})]
});
export default SvgDocumentLineColor;
